import React from "react"

class AlertWarning extends React.Component {
  render() {
    return (
      <div className="bg-orange-100 text-orange-500 text-semibold px-4 py-2 my-2 border-l-4 border-orange-500 rounded">
        {this.props.children}
      </div>
    )
  }
}

export default AlertWarning
